import { ActiveProgramModule, ProgramSegment } from '../../ProgramStore/Types';

// "Locked" is the outline's UI term for the backend's 'Inaccessible' segment status. Access is
// decided 100% server-side per segment; these helpers only read/mirror that decision so the
// segment and module notions of "locked" stay defined in one place and in sync across the panel.
export const isSegmentLocked = (segment: ProgramSegment): boolean =>
  segment.status === 'Inaccessible';

// Modules carry no backend lock field, so this is a display-only derivation: a module reads as
// locked when it's time-gated or every one of its segments is locked (Inaccessible).
export const isModuleLocked = (programModule: ActiveProgramModule): boolean =>
  programModule.isGated ||
  (programModule.segments.length > 0 && programModule.segments.every(isSegmentLocked));
